/*! RDB flow — site-wide intercept of refills to finish bundle */
(function () {
  'use strict';

  // ---- helpers -------------------------------------------------------------
  var PENDING_KEY = 'RDB_PENDING';

  function getPending() {
    try {
      return JSON.parse(localStorage.getItem(PENDING_KEY) || 'null');
    } catch (_) {
      return null;
    }
  }
  function clearPending() {
    try {
      localStorage.removeItem(PENDING_KEY);
    } catch (_) {}
  }

  // Build full bundle payload
  function buildItems(pkg, refillVid) {
    var gid =
      'rdb-' + Date.now().toString(36) + '-' + Math.floor(Math.random() * 1e6);
    // Persist active id so cart UI can tag/hide lines
    try {
      sessionStorage.setItem('pnmBundleId', gid);
    } catch (_) {}
    var items = [
      {
        id: pkg.parent,
        quantity: 1,
        properties: {
          'RDB group': gid,
          'RDB Kit': 'Reed Diffuser Builder',
          'RDB Summary': JSON.stringify(pkg.parts),
        },
      },
    ];
    ['bottle', 'cap', 'reeds'].forEach(function (role) {
      var id = pkg.parts && pkg.parts[role];
      if (id) {
        items.push({
          id: id,
          quantity: 1,
          properties: { 'RDB group': gid, _rdb_child: '1', 'RDB Role': role },
        });
      }
    });
    items.push({
      id: refillVid,
      quantity: 1,
      properties: {
        'RDB group': gid,
        _rdb_child: '1',
        'RDB Role': 'fragrance',
      },
    });
    return items;
  }

  // Heuristic: is the clicked/added product a 100ml Diffuser Refill?
  function isRefillCandidate(root) {
    // Grab the nearest product/card container (covers Boost/most themes)
    var host =
      root && root.closest
        ? root.closest(
            'form[action="/cart/add"], .product, .card, .product-item, .mz-item-card, .grid__item, [class*="product"], [class*="card"]'
          )
        : null;

    // 1) Raw text check on the whole card (most reliable with Boost swaps)
    var txt = (
      host && host.textContent
        ? host.textContent
        : document.body.textContent || ''
    ).toLowerCase();
    if (txt.indexOf('diffuser refill') !== -1) return true;

    // 2) Any link/handle hint if present
    var a = host ? host.querySelector('a[href*="/products/"]') : null;
    var href = a ? a.getAttribute('href') : location.pathname || '';
    if (/diffuser\-refill|100ml\-diffuser\-refill/i.test(href)) return true;

    // 3) Product page fallback
    if (
      location.pathname.indexOf('/products/') === 0 &&
      (/diffuser\-refill|100ml\-diffuser\-refill/i.test(location.pathname) ||
        /diffuser\s*refill/i.test(document.title))
    )
      return true;

    // 4) Form text fallback
    var form = host ? host.querySelector('form[action="/cart/add"]') : null;
    if (form && /refill/i.test(form.textContent || '')) return true;

    return false;
  }

  // Extract variant id from a form
  function getVariantIdFromForm(form) {
    var id = (
      form.querySelector('[name="id"]') ||
      form.querySelector('[name="variant"]') ||
      {}
    ).value;
    return id ? Number(id) : NaN;
  }

  // Post bundle
  function addBundle(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items }),
    });
  }

  // Show "Spend to Save" popup after adding bundle
  function showSpendToSavePopup() {
    var overlay = document.createElement('div');
    overlay.id = 'rdb-overlay';
    overlay.style.cssText =
      'position:fixed;inset:0;background:rgba(255,255,255,0.95);display:flex;align-items:center;justify-content:center;z-index:9999;font-family:"Petit Cochan","Fruity",sans-serif;text-align:center;padding:20px;';

    overlay.innerHTML =
      '<div id="rdb-popup" style="background:#fff;border-radius:16px;width:90%;max-width:560px;margin:auto;padding:32px 24px;box-shadow:0 4px 20px rgba(0,0,0,0.15);border:1mm solid rgb(185,104,41);text-align:center;">' +
      '<div style="background:#fff9f0;padding:20px;border-radius:12px;border:2px solid #FFA500;margin-bottom:24px;">' +
      '<h3 style="font-family:\'Fruity Juice\',sans-serif;font-size:1.5em;font-weight:700;color:#FFA500;margin:0 0 16px;">Spend to Save</h3>' +
      '<p style="margin:8px 0;font-size:1.05em;color:#7B4B29;line-height:1.5;"><strong>Add another Refill to get 10% off refills.</strong></p>' +
      '<p style="margin:8px 0;font-size:1.05em;color:#7B4B29;line-height:1.5;"><strong>Add 2 Refills to get 25% off refills</strong></p>' +
      '</div>' +
      '<div style="display:flex;gap:12px;justify-content:center;flex-wrap:wrap;">' +
      '<button class="rdb-popup-btn" id="rdb-pick-another" style="background:#FFA500;color:#fff;border:0;padding:14px 28px;border-radius:8px;font-size:1.05em;font-family:\'Fruity Juice\',\'Fruity\',sans-serif;font-weight:600;cursor:pointer;transition:all 0.2s ease;">Pick another..</button>' +
      '<button class="rdb-popup-btn" id="rdb-go-to-bag" style="background:#FFA500;color:#fff;border:0;padding:14px 28px;border-radius:8px;font-size:1.05em;font-family:\'Fruity Juice\',\'Fruity\',sans-serif;font-weight:600;cursor:pointer;transition:all 0.2s ease;">Go to bag..</button>' +
      '<button class="rdb-popup-btn" id="rdb-continue-shopping" style="background:#7B4B29;color:#fff;border:0;padding:14px 28px;border-radius:8px;font-size:1.05em;font-family:\'Fruity Juice\',\'Fruity\',sans-serif;font-weight:600;cursor:pointer;transition:all 0.2s ease;">Continue Shopping..</button>' +
      '</div>' +
      '</div>';

    document.body.appendChild(overlay);

    // Add hover effects via inline event handlers
    var btns = overlay.querySelectorAll('.rdb-popup-btn');
    btns.forEach(function (btn) {
      btn.addEventListener('mouseenter', function () {
        this.style.boxShadow = '0 2px 8px rgba(255,184,77,0.4)';
        this.style.transform = 'scale(1.05)';
      });
      btn.addEventListener('mouseleave', function () {
        this.style.boxShadow = 'none';
        this.style.transform = 'scale(1)';
      });
    });

    // Button click handlers
    document
      .getElementById('rdb-pick-another')
      .addEventListener('click', function (e) {
        e.preventDefault();
        // Stay on current page (refills collection) - just close popup
        document.body.removeChild(overlay);
      });

    document
      .getElementById('rdb-go-to-bag')
      .addEventListener('click', function (e) {
        e.preventDefault();
        location.href = '/cart';
      });

    document
      .getElementById('rdb-continue-shopping')
      .addEventListener('click', function (e) {
        e.preventDefault();
        location.href = '/';
      });

    // Close on overlay click
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        document.body.removeChild(overlay);
      }
    });
  }

  // ---- global intercepts ---------------------------------------------------
  function interceptForm(form) {
    if (form.__rdbBound) return;
    form.__rdbBound = true;

    form.addEventListener(
      'submit',
      function (ev) {
        var pkg = getPending();
        if (!pkg) return; // nothing pending → normal submit
        if (!isRefillCandidate(ev.target)) return; // not a refill → normal submit

        ev.preventDefault();
        var vid = getVariantIdFromForm(form);
        if (!vid) {
          form.submit();
          return;
        }

        clearPending();
        addBundle(buildItems(pkg, vid))
          .then(function (response) {
            if (!response.ok) throw new Error('Add failed');
            return response.json();
          })
          .then(function () {
            showSpendToSavePopup();
          })
          .catch(function (err) {
            console.error('RDB bundle add failed:', err);
            // Fallback: redirect to cart anyway
            location.href = '/cart';
          });
      },
      true
    );
  }

  function interceptClicks(e) {
    var targetBtn = e.target.closest(
      'form[action="/cart/add"] [type="submit"], button[name="add"], [data-add-to-cart]'
    );
    if (!targetBtn) return;

    var pkg = getPending();
    if (!pkg) return;
    if (!isRefillCandidate(targetBtn)) return;

    var form = targetBtn.closest('form[action="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    var vid = getVariantIdFromForm(form);
    if (!vid) {
      form.submit();
      return;
    }

    clearPending();
    addBundle(buildItems(pkg, vid))
      .then(function (response) {
        if (!response.ok) throw new Error('Add failed');
        return response.json();
      })
      .then(function () {
        showSpendToSavePopup();
      })
      .catch(function (err) {
        console.error('RDB bundle add failed:', err);
        // Fallback: redirect to cart anyway
        location.href = '/cart';
      });
  }

  function bindAll() {
    document
      .querySelectorAll('form[action="/cart/add"]')
      .forEach(interceptForm);
  }

  // Permanent, delegated intercepts (no rebinds needed)
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.matches('form[action="/cart/add"]')) return;

      var pkg = (function () {
        try {
          return JSON.parse(localStorage.getItem('RDB_PENDING') || 'null');
        } catch (_) {
          return null;
        }
      })();
      if (!pkg) return;
      if (!isRefillCandidate(form)) return;

      e.preventDefault();
      var vid = getVariantIdFromForm(form);
      if (!vid) {
        form.submit();
        return;
      }

      clearPending();
      addBundle(buildItems(pkg, vid))
        .then(function (response) {
          if (!response.ok) throw new Error('Add failed');
          return response.json();
        })
        .then(function () {
          showSpendToSavePopup();
        })
        .catch(function (err) {
          console.error('RDB bundle add failed:', err);
          // Fallback: redirect to cart anyway
          location.href = '/cart';
        });
    },
    true
  );

  // Also catch button clicks that bypass form submit
  document.addEventListener('click', interceptClicks, true);

  // Optional: one initial bind (harmless if interceptForm exists)
  document.addEventListener('DOMContentLoaded', function () {
    try {
      document
        .querySelectorAll('form[action="/cart/add"]')
        .forEach(interceptForm);
    } catch (_) {}
  });
})();
